import type { ReactNode } from 'react';
import { useMaintenanceStatus } from '@/hooks/useMaintenanceStatus';
import { MaintenanceOverlay } from './MaintenanceOverlay';

interface MaintenanceGateProps {
    children: ReactNode;
}

/**
 * Thin wrapper mounted at the App root (inside LanguageProvider, above
 * Suspense/Routes). Owns the maintenance-status polling and renders the
 * overlay as a sibling above the router output — route changes re-render
 * <Routes> but never unmount the gate.
 */
export function MaintenanceGate({ children }: MaintenanceGateProps) {
    const { status, refresh } = useMaintenanceStatus();

    return (
        <>
            {children}
            {status && <MaintenanceOverlay status={status} onLoginSuccess={refresh} />}
        </>
    );
}
